import React from 'react';

import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Recursos', href: '#features' },
      { label: 'Preços', href: '#pricing' },
      { label: 'Demonstração', href: '#demo' },
      { label: 'Atualizações', href: '#updates' },
    ],
    company: [
      { label: 'Sobre Nós', href: '#about' },
      { label: 'Blog', href: '#blog' },
      { label: 'Carreiras', href: '#careers' },
      { label: 'Contato', href: '#contact' },
    ],
    legal: [
      { label: 'Privacidade', href: '#privacy' },
      { label: 'Termos de Uso', href: '#terms' },
      { label: 'LGPD', href: '#lgpd' },
      { label: 'Cookies', href: '#cookies' },
    ],
    support: [
      { label: 'Central de Ajuda', href: '#help' },
      { label: 'Documentação', href: '#docs' },
      { label: 'Status', href: '#status' },
      { label: 'Suporte', href: '#support' },
    ],
  };

  const socialLinks = [
    { icon: 'Facebook', href: '#facebook', label: 'Facebook' },
    { icon: 'Instagram', href: '#instagram', label: 'Instagram' },
    { icon: 'Linkedin', href: '#linkedin', label: 'LinkedIn' },
    { icon: 'Twitter', href: '#twitter', label: 'Twitter' },
  ];

  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-blue-700 flex items-center justify-center">
                <Icon name="Activity" size={20} color="#FFFFFF" />
              </div>
              <span className="text-xl font-semibold">{import.meta.env.VITE_APP_TITLE}</span>
            </div>
            <p className="text-white/70 mb-6 max-w-sm">
              Plataforma completa de gestão para psicólogos modernos. Simplifique sua prática e foque no que realmente importa.
              <br /><br />
              Barra da Tijuca<br />
              Rio de Janeiro - (21) 97913-3438
            </p>
            <div className="flex items-center gap-4">
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.href}
                  aria-label={social?.label}
                  className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                  <Icon name={social?.icon} size={18} color="#FFFFFF" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Produto</h3>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Empresa</h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Suporte</h3>
            <ul className="space-y-3">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.href}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-sm">
              © {currentYear} {import.meta.env.VITE_APP_TITLE}. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm text-white/70">
              <span>Feito com ❤️ no Brasil</span>
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={16} color="#FFFFFF" />
                <span>LGPD Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;